module.exports = __webpack_public_path__ + "img/v0.bba77abc.png";